import React, { useContext } from 'react';
import { ResponsiveContext } from '../../contexts/ResponsiveContext';

const ProductsInfo = () => {
  const { is450, is1100, is1500 } = useContext(ResponsiveContext);

  return (
    <>
      <div className='d-flex row align-content-center justify-content-center'>
        <h6
          className={`${
            is1100 ? 'fs-2' : 'fs-4'
          } fw-bold text-muted fst-italic`}
          style={{
            boxShadow:
              'rgba(255, 120, 3, 0.4) 0px 5px, rgba(255, 120, 3, 0.3) 0px 10px, rgba(255, 120, 3, 0.2) 0px 15px, rgba(255, 120, 3, 0.1) 0px 20px, rgba(255, 120, 3, 0.05) 0px 25px',
            width: '80%',
            marginTop: '80px',
          }}
        >
          PRODUCTOS...
        </h6>
      </div>
      <div className='contactInfo container'>
        <div className=''>
          <div
            className={`d-flex ${
              is1500 ? 'justify-content-between' : 'justify-content-around'
            } `}
            style={{
              flexDirection: is450 ? 'row' : 'column',
              marginLeft: is450 ? '0px' : '30px',
            }}
          >
            <div className=''>
              <ol
                className={`'fs-6' mt-3 fw-bold text-uppercase`}
                style={{ color: 'rgba(255, 120, 3, 0.8)' }}
              >
                Natación
              </ol>
              <>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Bañadores de competición
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>Gafas</li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Gorros de baño
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Chanclas
                </li>
              </>

              <ol
                className={`'fs-6' mt-3 fw-bold text-uppercase`}
                style={{ color: 'rgba(255, 120, 3, 0.8)' }}
              >
                Calzado deportivo
              </ol>
              <>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Infantil
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>Paseo</li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Zapatillas de baloncesto
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Running
                </li>
              </>

              {!1500 && (
                <>
                  <ol
                    className={`'fs-6' mt-3 fw-bold text-uppercase`}
                    style={{ color: 'rgba(255, 120, 3, 0.8)' }}
                  >
                    Yoga
                  </ol>
                  <>
                    <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                      Colchonetas de yoga
                    </li>
                    <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                      Camisetas
                    </li>
                    <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                      Mallas
                    </li>
                  </>
                </>
              )}
            </div>
            {is1500 && (
              <div>
                <ol
                  className={`'fs-6' mt-3 fw-bold text-uppercase`}
                  style={{ color: 'rgba(255, 120, 3, 0.8)' }}
                >
                  Yoga
                </ol>
                <>
                  <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                    Colchonetas de yoga
                  </li>
                  <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                    Camisetas
                  </li>
                  <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                    Mallas
                  </li>
                </>
                <ol
                  className={`'fs-6' mt-3 fw-bold text-uppercase`}
                  style={{ color: 'rgba(255, 120, 3, 0.8)' }}
                >
                  Ropa
                </ol>
                <>
                  <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                    Chandals
                  </li>
                  <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                    Sudaderas
                  </li>
                  <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                    Pantalones
                  </li>
                  <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                    Textil para fitness
                  </li>
                </>
              </div>
            )}
            <div className=''>
              {!1500 && (
                <>
                  <ol
                    className={`'fs-6' mt-3 fw-bold text-uppercase`}
                    style={{ color: 'rgba(255, 120, 3, 0.8)' }}
                  >
                    Ropa
                  </ol>
                  <>
                    <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                      Chandals
                    </li>
                    <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                      Sudaderas
                    </li>
                    <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                      Pantalones
                    </li>
                    <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                      Textil para fitness
                    </li>
                  </>
                </>
              )}

              <ol
                className={`'fs-6' mt-3 fw-bold text-uppercase`}
                style={{ color: 'rgba(255, 120, 3, 0.8)' }}
              >
                Complementos
              </ol>
              <>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Balones
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Mochilas
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Bolsas de deporte
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Calcetines
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Bermudas
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>
                  Cinturones de judo
                </li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>Mats</li>
                <li className={`fw-bold ${is1500 ? 'my-4' : 'my-2'}`}>Pesas</li>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductsInfo;
